import { render, staticRenderFns } from "./index.vue?vue&type=template&id=0147cf32"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/html/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0147cf32')) {
      api.createRecord('0147cf32', component.options)
    } else {
      api.reload('0147cf32', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=0147cf32", function () {
      api.rerender('0147cf32', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/async-info/index.vue"
export default component.exports